import { useEffect } from 'react'
import ErrorStep from '../formSteps/ErrorStep'
import Loading from '../formSteps/Loading'
import { Odyssey } from '@redventures/odyssey'
import { useStoreState } from '../../store/useStore'
import type { FormStepResult as OdysseyFormStepResult } from '@redventures/odyssey'
import type { FormStepResult } from '../../types'
import type { StepLoadedHook } from '../../../types/lifecycle-hooks'
import type { FmpFormStep } from '../../../types/form'

export interface QuestionnaireProps {
  formFlow: FmpFormStep[]
  handleFinish: (results: FormStepResult) => void
  handleNext: (stepName: string, results: FormStepResult) => void
  handleBack: (stepName: string, results: FormStepResult) => void
  errorCta: () => void
  handleError: (error: unknown) => void
  onStepLoaded: StepLoadedHook
}

export function Questionnaire({
  formFlow,
  handleFinish,
  handleNext,
  handleBack,
  errorCta,
  handleError,
  onStepLoaded,
}: QuestionnaireProps) {
  const formResults = useStoreState((state) => state.form.formResults)
  const isFormCompleted = useStoreState((state) => state.form.isFormCompleted)
  const currentStepIndex = useStoreState((state) => state.form.currentStepIndex)

  useEffect(() => {
    if (currentStepIndex === null || currentStepIndex === undefined) return

    const stepName = formFlow[currentStepIndex]?.name
    if (!stepName) return // Safety check for edge cases

    requestAnimationFrame(() => {
      onStepLoaded(currentStepIndex, stepName)
    })
  }, [currentStepIndex, formFlow, onStepLoaded])

  // Create a wrapper to be able to pass through callback prop
  const ErrorStepWrapper = () => <ErrorStep onError={() => errorCta()} />

  return (
    <div className='strata:bg-white'>
      {!isFormCompleted ? (
        <Odyssey
          CurrentStepIndex={currentStepIndex ?? 0}
          FormFlow={formFlow}
          FormStepResults={(formResults as Record<string, OdysseyFormStepResult>) ?? {}}
          Error={ErrorStepWrapper}
          Loading={Loading}
          onFinish={handleFinish}
          onNext={handleNext}
          onBack={handleBack}
          onError={handleError}
        />
      ) : null}
    </div>
  )
}
